import React, { Component } from 'react';
import Search from '../../../components/Search';
import DataTable from '../../../components/DataTable';
import { connect } from 'react-redux'
import {Card, CardBody, CardTitle, CardHeader} from "reactstrap";
import { setSearchData } from '../../../actions/search';
import {deleteFile} from '../../../actions/file'
import lodash  from 'lodash/array';
import { getAllFiles }  from '../../../actions/file';
import { getAllProducts } from '../../../actions/product';
import {fileTypeFetchData, fileMetaDataValueWithCategoryFetchData} from '../../../actions/fileData'
import Loader from '../../../components/Loader';
import { setSearchScope } from '../../../helpers';
import moment from 'moment';

class Overview extends Component {

	constructor(props,context) {
        super(props,context);

        this.columns = [{
              Header: 'Bestandsnaam',
              accessor: 'filename',
              Cell: props => <span><a target="_blank" href={props.row._original.source} style={{display : 'inline'}} className="nav-link">{props.value}</a></span>
        },{
              Header: 'Bestandstype',
              accessor: 'file_type_name',
        },{
              Header: 'Valt onder product',
              accessor: 'product_name',
        },{
            Header: 'Upload datum',
            accessor: 'upload_date',
            sortMethod: (a, b) => {
                a = parseInt(moment(a, 'DD-MM-YYYY HH:mm:ss').toDate().getTime());
                b = parseInt(moment(b, 'DD-MM-YYYY HH:mm:ss').toDate().getTime())
                if (a === b) {
                  return a > b ? 1 : -1;
                }
                return a > b ? 1 : -1;
              }


        },{
              Header: 'Geupload door',
              accessor: 'uploaded_by_name',
        }
        ]

        this.additionalColumns = [
        {
                Header: 'Is verstuurd naar klant?',
                accessor: 'is_been_notified',
                Cell: props => <span>{props.value == '1' ? <i className="fa fa-check"></i> : <i className="fa fa-times"></i>}</span>
        },
        {
            Header: 'Aanpassen',
            accessor: 'id',
            Cell: props => <span><a href={'/#/files/update/'+props.value} style={{display : 'inline'}} className="nav-link"><i className="fa fa-pencil"></i> Bewerken</a></span>
        }, {
            Header: '#',
            accessor: 'id',
            Cell: props => <span><a onClick={(e, file, value) => this.deleteFile(e, props.row._original.id, props.row._original.is_deleted)} href="#" style={{display : 'inline'}} className="nav-link">{props.row._original.is_deleted == '1' ? 'Herstellen' : 'Verwijderen'}</a></span>
        }
        ]

    }

    deleteFile(e, file, value) {
        e.preventDefault();

        const fileIndex = lodash.findIndex(this.props.fileData.files, function(value) { return value.id === file; });

        // -- get address index to update firebase
        const dp_address_id = this.props.fileData.files[fileIndex].addresses[0].value;
        const addressIndex = lodash.findIndex(this.props.clientData.allAddresses, function(value) { return value.dp_address_id === dp_address_id; });

        let addressFileIndex = false;

        if('files' in this.props.clientData.allAddresses[addressIndex])
        {


          addressFileIndex = lodash.findIndex(this.props.clientData.allAddresses[addressIndex].files, function(value) { return value.id === file; });

          // -- address has files but this file is already deleted from the address
          if(addressFileIndex == '-1') {
              addressFileIndex = lodash.lastIndexOf(this.props.clientData.allAddresses[addressIndex].files);

              if(addressFileIndex == '-1') {
                addressFileIndex = 0;
              }
          }
        } else {
          addressFileIndex = 0;
        }

        if(fileIndex == '-1')
        {
            return false;
        }

        this.props.deleteFile(
            this.props.clientPath.clientPath,
            file,
            value == 1 ? 0 : 1,
            addressIndex,
            fileIndex,
            addressFileIndex
        );

      // -- set file to value
      this.props.fileData.files[fileIndex].is_deleted = (value == 1 ? 0 : 1);
      // -- update searchdata
      this.props.updateSearchData(this.props.fileData.files);
    }

    componentWillMount() {
		setSearchScope('files');
        if(this.props.clientPath.clientPath) {
            this.props.getAllFiles(this.props.clientPath.clientPath)
            this.props.getAllProducts(this.props.clientPath.clientPath)
            this.props.fileTypeFetchData(this.props.clientPath.clientPath)
            this.props.fileMetaDataValueWithCategoryFetchData(this.props.clientPath.clientPath)
        }
    }

	componentDidUpdate(prevProps) {

        if(prevProps.fileData != this.props.fileData)
            this.props.updateSearchData(this.props.fileData.files)
    }

    componentDidMount() {
        window.scrollTo(0, 0)
    }



	render() {
          const filterValues = {
            showDeleted : {
                name: 'Alleen verwijderde bestanden laten zien',
                type: 'checkbox',
                key: 'is_deleted',
                value : '1'
            },
            showNotDeleted : {
                name: 'Alleen niet verwijderde bestanden laten zien',
                type: 'checkbox',
                key: 'is_deleted',
                value : '0'
            }
        }

        return (

            <div className="animated fadeIn">
                <Card>
                    <CardHeader><Search filters={filterValues} data={this.props.fileData.files} keys_to_filter={['filename', 'product_name', 'upload_date', 'uploaded_by_name', 'file_type_name','metaDataValues']}/></CardHeader>
                    <CardBody>
                        <CardTitle><i className="fa fa-file"></i> Bestanden overzicht</CardTitle>
        {this.props.searchData.data ? <DataTable  additionalColumns={this.additionalColumns} data={this.props.searchData.data ? this.props.searchData.data : this.props.fileData.files} columns={this.columns} /> : <Loader /> }
                    </CardBody>
                </Card>

            </div>
        )
  	}
}


function mapStateToProps(state, ownProps) {

    return {
        fileData: state.FileReducer.files,
        searchData: state.SearchDataReducer,
        clientPath: state.clientPathReducer,
        clientData: state.ClientDataReducer,

    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        updateSearchData: (data) => dispatch(setSearchData(data)),
        getAllFiles: (url) => dispatch(getAllFiles(url)),
        getAllProducts: (url) => dispatch(getAllProducts(url)),
        fileTypeFetchData: (url) =>   dispatch(fileTypeFetchData(url + '/api/files/action/getFileTypes')),
        fileMetaDataValueWithCategoryFetchData: (url) => dispatch(fileMetaDataValueWithCategoryFetchData(url + '/api/files/action/getMetaValuesByCategory')),
        deleteFile:(clientPath, fileId, value, addressIndex, fileIndex, addressFileIndex) => dispatch(deleteFile(clientPath, fileId, value, addressIndex, fileIndex, addressFileIndex))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Overview)



// WEBPACK FOOTER //
// ./src/views/Files/Overview/index.js